/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import moment from 'moment';

export const isValidDate = (date) => moment(date).isValid();

export const formatDateHyphen = (date) =>
  isValidDate(date) ? moment(date).format('YYYY-MM-DD') : undefined;

export const formatDateSlash = (date) =>
  isValidDate(date) ? moment(date).format('MM/DD/YY') : undefined;

export const dateRange = (cadence) =>
  `${formatDateSlash(cadence.start_date)} - ${formatDateSlash(
    cadence.end_date
  )}`;

export const differenceBetweenDateFromToday = (date) => {
  return moment(date, 'YYYY-MM-DD').fromNow();
};
